export const combinatorColumns = [
    { title: "N° posizioni", dataIndex: "numberPositions", key: "numberPositions" },
    { title: "N° assistiti", dataIndex: "numberAssisted", key: "numberAssisted" },
    { title: "Anno", dataIndex: "year", key: "year" },
    { title: "Codice esenzione", dataIndex: "exemptionCode", key: "exemptionCode" },
    { title: "Tipo", dataIndex: "type", key: "type" },
    { title: "Importo", dataIndex: "amount", key: "amount" },
    { title: "Ticket", dataIndex: "ticket", key: "ticket" },
];
